import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { WorkproductProvider } from "../Context/WorkproductContext";
import DocumentAgentLG from "../WorkProductPage/DocumentAgentLG/DocumentAgentLG";
import WorkspaceHeader from "../WorkProductPage/Workspace/WorkspaceHeader";

export default function SharedWorkproductPage() {
  const { id } = useParams();
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    setData(null); setError("");
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/shared/workproduct/${id}`, { signal: controller.signal })
      .then(async response => { if (!response.ok) throw new Error("This shared document is unavailable."); return response.json(); })
      .then(result => { if (result.type !== "TipTap Document Agent") throw new Error("This document type is not available in Reviewed."); setData(result); })
      .catch(err => { if (!controller.signal.aborted) setError(err.message); });
    return () => controller.abort();
  }, [id]);
  if (error) return <div className="reviewed-loading" role="alert">{error}</div>;
  if (!data) return <div className="reviewed-loading" role="status">Opening shared document…</div>;
  return <WorkproductProvider key={id} initialWorkproduct={{ ...data, id }} initialFileContent={JSON.stringify(data.fileContent)} readOnly>
    <main className="wp-workspace wp-workspace--immersive"><WorkspaceHeader name={`${data.name} · Shared view`} /><div className="wp-workspace-body">
      <DocumentAgentLG readOnly sharedChatHistory={data.chatHistory} sharedAvailableChats={data.availableChats} sharedChatHistories={data.chatHistories} />
    </div></main>
  </WorkproductProvider>;
}
